import styles from './MessageBar.module.scss';
import { icons } from '../../assets';
import { CircularProgress } from '../../common';
const { FilledInfoIcon } = icons;

export const MessageBar = ({
  loading = false,
  style,
  titleStyle,
  text,
  actions,
  keepActionNextAfterText = false,
}) => {
  return (
    <div className={styles.container} style={style}>
      <div className={styles.content}>
        {
          loading
          ? <CircularProgress size={24} thickness={1} />
          : <FilledInfoIcon className={styles.icon} />
        }
        <p className={styles.title} style={titleStyle}>
          <span className={`me-2 ${styles.textBody}`}>{text}</span>{' '}
          {keepActionNextAfterText && actions && <>{actions}</>}
        </p>
      </div>
      {!keepActionNextAfterText && actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
};
